import { useState } from 'react';

const defaultModalConfig = {
  isOpen: false,
  width: 'auto',
  height: 'auto'
};

const useModalHandler = () => {
  const [modalConfig, setModalConfig] = useState(defaultModalConfig);

  const closeModal = () =>
    setModalConfig({
      ...defaultModalConfig,
      isOpen: false
    });

  const openModal = ({ stickToTop, ...options }) =>
    setModalConfig(prevConfig => ({
      ...prevConfig,
      isOpen: true,
      onClose: closeModal,
      ...options,
      ...(stickToTop && {
        wrapperProps: { style: { position: 'absolute', top: '8%' } }
      })
    }));

  return {
    closeModal,
    openModal,
    modalConfig
  };
};

export default useModalHandler;
